"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentRoleEntityType = exports.AssignmentRoleType = exports.DepartmentRole = exports.ExternalAssignmentRole = exports.ProducerAssignmentRole = exports.AccountManagementAssignmentRole = void 0;
var AccountManagementAssignmentRole;
(function (AccountManagementAssignmentRole) {
    AccountManagementAssignmentRole["CSA"] = "CSA";
    AccountManagementAssignmentRole["PRIMARY_ACCOUNT_MANAGER"] = "PRIMARY_ACCOUNT_MANAGER";
    AccountManagementAssignmentRole["SECONDARY_ACCOUNT_MANAGER"] = "SECONDARY_ACCOUNT_MANAGER";
})(AccountManagementAssignmentRole = exports.AccountManagementAssignmentRole || (exports.AccountManagementAssignmentRole = {}));
var ProducerAssignmentRole;
(function (ProducerAssignmentRole) {
    ProducerAssignmentRole["PRIMARY_PRODUCER"] = "PRIMARY_PRODUCER";
    ProducerAssignmentRole["SECONDARY_PRODUCER"] = "SECONDARY_PRODUCER";
})(ProducerAssignmentRole = exports.ProducerAssignmentRole || (exports.ProducerAssignmentRole = {}));
var ExternalAssignmentRole;
(function (ExternalAssignmentRole) {
    ExternalAssignmentRole["CLAIM_EDITOR"] = "CLAIM_EDITOR";
    ExternalAssignmentRole["CLAIM_VIEWER"] = "CLAIM_VIEWER";
    ExternalAssignmentRole["CLIENT_USER_ADMIN"] = "CLIENT_USER_ADMIN";
})(ExternalAssignmentRole = exports.ExternalAssignmentRole || (exports.ExternalAssignmentRole = {}));
var DepartmentRole;
(function (DepartmentRole) {
    DepartmentRole["PERSONAL_LINES_ACCOUNT_MANAGER"] = "Personal Lines Account Manager";
    DepartmentRole["COMMERCIAL_LINES_ACCOUNT_MANAGER"] = "Commercial Lines Account Manager";
    DepartmentRole["EMPLOYEE_BENEFITS_ACCOUNT_MANAGER"] = "Employee Benefits Account Manager";
    DepartmentRole["COMMERCIAL_LINES_PRODUCER"] = "Commercial Lines Producer";
    DepartmentRole["PERSONAL_LINES_PRODUCER"] = "Personal Lines Producer";
    DepartmentRole["EMPLOYEE_BENEFITS_PRODUCER"] = "Employee Benefits Producer";
})(DepartmentRole = exports.DepartmentRole || (exports.DepartmentRole = {}));
/**
 * This is an enum of user types.
 * Used to create a list of role assignment options to user type.
 */
var AssignmentRoleType;
(function (AssignmentRoleType) {
    AssignmentRoleType["CLIENT"] = "CLIENT";
})(AssignmentRoleType = exports.AssignmentRoleType || (exports.AssignmentRoleType = {}));
/**
 * This is an enum of entity types.
 * Used to create a list of role assignment options to entity type.
 */
var AssignmentRoleEntityType;
(function (AssignmentRoleEntityType) {
    AssignmentRoleEntityType["CLAIM"] = "CLAIM";
    AssignmentRoleEntityType["ADMIN"] = "ADMIN";
})(AssignmentRoleEntityType = exports.AssignmentRoleEntityType || (exports.AssignmentRoleEntityType = {}));
//# sourceMappingURL=types.js.map